<p>auth-module works!</p>
